/* eslint-disable no-unused-vars */
// @flow

import React from 'react';
import cx from 'classnames';
import { useSelector } from 'react-redux';
import styles from './styles.module.scss';
import { Switch } from 'components';

const rowNames = [
  '', '', 'EP', 'MP', 'CO', 'BU', 'SB', 'BB', '',
];

const colNames = [
  '', '', 'EP', 'MP', 'CO', 'BU', 'SB', 'BB', '',
];

type Props = {
  setSelectedTable: (any) => void,
  onSetStake: (any) => void,
  setPercents: (any) => void,
  tableData: Array<any>,
  easyRFI: boolean,
  setEasyRFI: () => void,
}

const SituationTable = ({
  setSelectedTable,
  onSetStake,
  tableData,
  setPercents,
  easyRFI,
  setEasyRFI,
}: Props) => {
  const { user } = useSelector((state) => state.profile);
  const isTrial = user?.rate?.toLowerCase() === 'trial';
  const correctedData = tableData.filter((item) => item.x !== 0 && item.y !== 0);

  const handleClick = (num, stake) => {
    setSelectedTable(num);
    onSetStake(stake);
  };

  const checkExlusionVSByColor = (barName: string) => (
    barName === 'EP'
      || barName === 'MP'
      || barName === 'CO'
      || barName === 'BU'
      || barName === 'SB'
      || barName === 'SB no limp'
  );

  const setCells = (x, indexX, y, indexY, dataArr) => {
    if ((dataArr.filter((item) => (item.y === indexX && item.x === indexY))).length) {
      const isComplexButton = (indexX === 6 && indexY === 1) || (indexX === 7 && indexY === 6);
      const itemsLength = (dataArr.filter((item) => (
        item.y === indexX && item.x === indexY))).length;

      if (isComplexButton && itemsLength === 2) {
        const items = (dataArr.filter((item) => (
          item.y === indexX && item.x === indexY))).sort((a, b) => a.name.includes('no limp') - b.name.includes('no limp'));

        const barName1 = items[0].name;
        const barName2 = items[1].name;
        const percents1 = items[0].percents;
        const percents2 = items[1].percents;
        const isExclusionVSByColor1 = checkExlusionVSByColor(barName1);
        const isExclusionVSByColor2 = checkExlusionVSByColor(barName2);
        const type1 = items[0].type;
        const type2 = items[1].type;
        const isSmallText1 = barName1 === 'SB no limp' || barName1 === 'vs SB no limp';
        const isSmallText2 = barName2 === 'SB no limp' || barName2 === 'vs SB no limp';

        return (
          <>
            <button
              onMouseOver={() => setPercents(percents1)}
              onFocus={() => setPercents(percents1)}
              onMouseOut={() => setPercents('')}
              onBlur={() => setPercents('')}
              key={`${indexX}_${indexY}_1`}
              type="button"
              onClick={() => {
                handleClick(2, type1);
                setPercents(percents1);
              }}
              className={cx(
                styles.fullCell,
                styles.halfCell,
                styles.rightBorder,
                (indexX < indexY ? styles.redCell : styles.blueCell),
                { [`${styles.disable}`]: (isTrial) },
                { [styles.exclusionVSByColor]: isExclusionVSByColor1 },
                { [styles.smallText]: isSmallText1 },
              )}
              disabled={(isTrial)}
            >
              {barName1}
            </button>
            <button
              onMouseOver={() => setPercents(percents2)}
              onFocus={() => setPercents(percents2)}
              onMouseOut={() => setPercents('')}
              onBlur={() => setPercents('')}
              key={`${indexX}_${indexY}_2`}
              type="button"
              onClick={() => {
                handleClick(2, type2);
                setPercents(percents2);
              }}
              className={cx(
                styles.fullCell,
                styles.halfCell,
                (indexX < indexY ? styles.redCell : styles.blueCell),
                { [`${styles.disable}`]: (isTrial) },
                { [styles.exclusionVSByColor]: isExclusionVSByColor2 },
                { [styles.smallText]: isSmallText2 },
              )}
              disabled={(isTrial)}
            >
              {barName2}
            </button>
          </>
        );
      }

      const isCO = indexX === 4 && indexY === 1;
      const barName = (dataArr.filter((item) => (
        item.y === indexX && item.x === indexY)))[0].name;
      const { percents } = (dataArr.filter((item) => (
        item.y === indexX && item.x === indexY)))[0];
      const isExclusionByColor = barName === 'CO4bet vs EP+MP3bet'
        || barName === 'BU4bet vs MP+CO3bet'
        || barName === 'SB4bet vs CO+BU3bet'
        || barName === 'BB4bet vs BU+SB3bet'
        || barName === 'SB4bet vs EP+MP3bet';

      const isExclusionSQZByColor = barName === 'EP vs sqz'
        || barName === 'MP vs sqz'
        || barName === 'CO vs sqz'
        || barName === 'BU vs sqz';

      const isExclusionVSByColor = checkExlusionVSByColor(barName);
      // const percents = {
      //   ip: {
      //     fold: '123%',
      //     call: '13%',
      //     raise: '12%',
      //   },
      //   oop: {
      //     fold: '13%',
      //     call: '79%',
      //     raise: '9%',
      //   },
      // };

      return (
        <button
          onMouseOver={() => setPercents(percents)}
          onFocus={() => setPercents(percents)}
          onMouseOut={() => setPercents('')}
          onBlur={() => setPercents('')}
          key={`${indexX}_${indexY}`}
          type="button"
          onClick={() => {
            handleClick(2, `${((dataArr.filter((item) => (
              item.y === indexX && item.x === indexY)))[0].type)}`);
            setPercents(percents);
          }}
          className={cx(
            styles.fullCell,
            (indexX < indexY ? styles.redCell : styles.blueCell),
            { [`${styles.disable}`]: (isTrial && !isCO) },
            { [styles.exclusionByColor]: isExclusionByColor },
            { [styles.exclusionSQZByColor]: isExclusionSQZByColor },
            { [styles.exclusionVSByColor]: isExclusionVSByColor },
          )}
          disabled={(isTrial && !isCO)}
        >
          {barName}
        </button>
      );
    }
    if (indexY === 0 && indexX > 0) {
      return <div key={`${indexX}_${indexY}`} className={styles.labelCells}>{colNames[indexX]}</div>;
    }
    if (indexX === 0 && indexY > 0) {
      return <div key={`${indexX}_${indexY}`} className={styles.labelCells}>{rowNames[indexY]}</div>;
    }

    // if (indexY === 1 && indexX === 1) {
    //   return (
    //     <div key={`${indexX}_${indexY}`} className={`${styles.same} ${styles.easyButton}`}>
    //       <span>Easy RFI</span>
    //       <Switch
    //         isOn={easyRFI}
    //         handleToggle={() => setEasyRFI(!easyRFI)}
    //       />
    //     </div>
    //   );
    // }
    if (!(dataArr.filter((item) => (item.y === indexX && item.x === indexY))).length
      && indexX > 0
      && indexX !== indexY) {
      return <div key={`${indexX}_${indexY}`} className={styles.empty} />;
    }
    return <div key={`${indexX}_${indexY}`} className={styles.same} />;
  };

  return (
    <section className={styles.matrix}>
      {rowNames.map((cellY, y) => (
        // eslint-disable-next-line react/no-array-index-key
        <div className={styles.row} key={y}>
          {colNames.map((cellX, x) => (
            // eslint-disable-next-line react/no-array-index-key
            <div key={`${x}_${y}`} className={styles.cell}>{setCells(cellX, x, cellY, y, correctedData)}</div>
          ))}
        </div>
      ))}
    </section>
  );
};

export default SituationTable;
